import styles from "./styles.module.css";

interface Props {
  text: string;
  className?: string;
}

export const LoadingText = ({ text = "Загрузка" }: Props) => {
  return (
    <span className={styles["loader"]}>
      {text}
      <span className={styles["loader-dots"]}>
        {" "}
        <span>.</span>
        <span>.</span>
        <span>.</span>
      </span>
    </span>
  );
};
